import { collection, doc, getDoc, getDocs, query, serverTimestamp, updateDoc, where } from "firebase/firestore";
import { db } from "../firebase";

export async function getUsersSummary() {
  const usersSnapshot = await getDocs(collection(db, "users"));
  const users = usersSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  const activeUsers = users.filter((user) => user.isActive === true || user.isBlocked === false);

  return {
    users,
    totalUsers: users.length,
    activeUsers: activeUsers.length,
  };
}

export async function getNewUsersSince(date) {
  const usersQuery = query(collection(db, "users"), where("createdAt", ">=", date));
  const snapshot = await getDocs(usersQuery);
  return snapshot.size;
}

export async function getUserProfile(userId) {
  const userRef = doc(db, "users", userId);
  const snapshot = await getDoc(userRef);
  return snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null;
}

export async function updateUserProfile(userId, payload) {
  const userRef = doc(db, "users", userId);
  return updateDoc(userRef, {
    ...payload,
    updatedAt: serverTimestamp(),
  });
}

export async function updateUserLearningPreferences(userId, preferences) {
  return updateUserProfile(userId, {
    ...preferences,
    profileCompleted: true,
    onboardingCompleted: true,
  });
}
